var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGreenTickIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2397 15.5292L21.6663 33.3772L12.093 23.6813L8.33301 27.5001L21.6663 41.0417L42.9997 19.3751L39.2397 15.5292ZM26.9997 0.416748C12.2797 0.416748 0.333008 12.5501 0.333008 27.5001C0.333008 42.4501 12.2797 54.5834 26.9997 54.5834C41.7197 54.5834 53.6663 42.4501 53.6663 27.5001C53.6663 12.5501 41.7197 0.416748 26.9997 0.416748ZM26.9997 49.1667C15.213 49.1667 5.66634 39.4709 5.66634 27.5001C5.66634 15.5292 15.213 5.83341 26.9997 5.83341C38.7863 5.83341 48.333 15.5292 48.333 27.5001C48.333 39.4709 38.7863 49.1667 26.9997 49.1667Z",
    fill: "#2ABF86"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenTickIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/green_tick_icon.3606105c.svg";
export { ForwardRef as ReactComponent };